var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.62 7.198H3.233v-.863l18.82-1.518v1.518h2.567V3.747c0-1.898-1.525-3.23-3.386-2.962L4.054 3.259C2.191 3.529.667 5.3.667 7.199v17.254c0 .915.36 1.793 1.002 2.44a3.408 3.408 0 002.42 1.01h20.53c.908 0 1.779-.363 2.42-1.01a3.466 3.466 0 001.003-2.44V10.649a3.46 3.46 0 00-1.003-2.44 3.407 3.407 0 00-2.42-1.01zm-2.567 12.089a2.548 2.548 0 01-1.815-.76 2.59 2.59 0 01-.751-1.83 2.61 2.61 0 01.753-1.83 2.565 2.565 0 011.815-.758c.68 0 1.334.273 1.815.758a2.6 2.6 0 01-.001 3.662 2.556 2.556 0 01-1.816.758z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIconWhite);
export default __webpack_public_path__ + "static/media/payment-icon-white.9de4051ebaa6029d82a6d694745ba186.svg";
export { ForwardRef as ReactComponent };